interface HeadCell {
  id: number;
  label: string;
}
const headCells: readonly HeadCell[] = [
  {
    id: 1,
    label: '',
  },
  {
    id: 2,
    label: 'Адрес',
  },
  {
    id: 3,
    label: 'Дата поступления',
  },
  {
    id: 4,
    label: 'Телефон',
  },
  {
    id: 5,
    label: 'Комментарий',
  },
  {
    id: 6,
    label: '',
  },
];

export default headCells;
